import { Box, Typography } from "@mui/material";

const EmptyState = ({ icon: Icon, title, description }) => (
	<Box
		sx={{
			height: "100%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			gap: 1,
			py: 6,
			color: "text.secondary",
		}}
	>
		<Icon sx={{ fontSize: 48, color: "#B9C7DC" }} />
		<Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1D54A2" }}>
			{title}
		</Typography>
		{description && (
			<Typography variant="body2" sx={{ color: "text.secondary" }}>
				{description}
			</Typography>
		)}
	</Box>
);

export default EmptyState;
